import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { layoutPublicStyle } from "../../../styles/layout/public-routes";
import { MobileMenuProps } from "../../../types/mobile-menu";

export function Header({ mobileMenu, setMobileMenu }: MobileMenuProps) {
  return (
    <Stack
      component="header"
      direction="row"
      justifyContent="space-between"
      sx={{ minHeight: "110px", width: "100%" }}
    >
      <Box sx={{ display: "flex", alignItems: "start" }} height={100}>
        <Box
          component="img"
          src="/assets/logo/logo-pita-ungu.svg"
          alt="logo_pita_ungu"
          sx={layoutPublicStyle.headerImgPitaBiru}
        />
        <Box
          component="img"
          src="/assets/logo/new-header-alesa.png"
          alt="logo_alesa"
          sx={layoutPublicStyle.headerImgLogoBinus}
        />
      </Box>
    </Stack>
  );
}
